import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { translate } from 'translations/i18n';
import { AssetThumbnail, ButtonIcon, Tooltip } from '@companycam/slab-web';

import { referencePhotosView } from '../constants';

const NOOP = () => {};

// #region styled-components
const Flex = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--cc_size_spacing_s);
  margin: var(--cc_size_spacing_l) 0 var(--cc_size_spacing_m);
`;

// #endregion

const ReferenceAssetGrid = ({
  assets = [],
  setSelectedView,
  setReferencePhotoId,
  viewOnly,
}) => {
  const handleOnClick = (id) => {
    setReferencePhotoId(id);
    setSelectedView(referencePhotosView.CONFIRM_DELETE);
  };

  if (!assets.length) {
    return null;
  }

  return (
    <Flex>
      {assets.map((asset) => (
        <AssetThumbnail
          key={asset.id}
          image={{
            src: asset.thumbnailUrl,
            alt: '',
          }}
          size="medium"
          contentTopRight={
            !viewOnly
              ? {
                  content: (
                    <Tooltip
                      title={translate(
                        'projects.taskList.removeReferenceAsset',
                      )}
                    >
                      <ButtonIcon
                        accessibilityLabel={translate(
                          'projects.taskList.removeReferenceAsset',
                        )}
                        onClick={() => handleOnClick(asset.id)}
                        iconName="delete"
                        size="small"
                      />
                    </Tooltip>
                  ),
                  shouldShowOnHover: true,
                }
              : null
          }
        />
      ))}
    </Flex>
  );
};

ReferenceAssetGrid.defaultProps = {
  viewOnly: false,
  setReferencePhotoId: NOOP,
  setSelectedView: NOOP,
};

ReferenceAssetGrid.propTypes = {
  assets: PropTypes.array.isRequired,
  setReferencePhotoId: PropTypes.func,
  setSelectedView: PropTypes.func,
  viewOnly: PropTypes.bool,
};

export default ReferenceAssetGrid;
